import { TabPanel, TabPanels } from "@chakra-ui/react";
import { PhysicalRiskAssessmentForm } from "../PhysicalRiskAssessmentForm";

function LocationsTabPanels({
                              defaultValues,
                              onTabChange,
                              action,
                              setAction,
                              locations,
                              finalize,
                              tabsCollapsed,
                              returnToListRequested,
                              returnToList
                            }) {
  return (
    <TabPanels maxWidth={`calc(100% - var(--chakra-sizes-${tabsCollapsed ? 12 : 60}))`}>
      {locations.map((location, index) => {
        const handleLocationChange = () => {
          if (action === "next") {
            onTabChange((prev) => prev + 1);
          } else if (action === "prev") {
            onTabChange((prev) => prev - 1);
          }
          setAction("");
        };

        return (
          <TabPanel key={`tabpanel_${location.id}`} blockSize="full" padding="0" paddingInline="5">
            <PhysicalRiskAssessmentForm
              tabKey={location.id}
              physicalRiskId={defaultValues.id}
              currentElement={location}
              defaultValues={defaultValues}
              handleLocationChange={handleLocationChange}
              finalize={finalize}
              returnToListRequested={returnToListRequested}
              returnToList={returnToList}
            />
          </TabPanel>
        );
      })}
    </TabPanels>
  );
}

export default LocationsTabPanels;
